var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-component"},[_c('Head',{staticClass:"head-wrapper"}),_c('Main',{staticClass:"main-wrapper"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }